import ApiUDS from "../../../gd/api/universal-data-selector"
import {ProjectAccess} from "../../../gd/const/project"
import {MissingUsersTeamsManagerInterface} from "../../components/add-missing-users-and-teams/missing-users-teams-manager-interface"
import ProjectUsersFullCollection from "../../../model2/project-user/collection-full";
import ProjectUserFull from "../../../model2/project-user/project-user-full";
import ProjectUserSession from "../../../model2/project-user/project-user-session";

export type ModalMoveTo_MissingUsersTeams = {
    // projectTeamIds      : ID[]
    workspaceTeamIds    : ID[]

    projectUserIds      : ID[]
    workspaceUserIds    : ID[]
}

// const debug = "Modal_getMissingUsersTeams"
const debug = false

export default async function Modal_getMissingUsersTeams(manager: MissingUsersTeamsManagerInterface): Promise<ModalMoveTo_MissingUsersTeams>{

    let addUsersToTargetWorkspace = true
    let addUsersToTargetProject = manager.showProjectAccess

    let response
    let movedItemsUsersIds: any[] = []
    let movedItemsTeamIds: any[] = []

    debug && console.log(debug, 'process start', addUsersToTargetWorkspace, addUsersToTargetProject, manager.targetProject, manager.affectedTasksIds, manager.affectedProjectIds)

    // collect task users
    if (!_.isEmpty(manager.affectedTasksIds)) {
        const response = await ApiUDS.getTasksProjectsUsersRecursively(manager.affectedTasksIds).promise()
        _.map(response, (taskUser: any) => {
            movedItemsUsersIds.push(taskUser.userId)
        })

        movedItemsUsersIds = _.uniq(movedItemsUsersIds)
    }

    // collect project users
    if (!_.isEmpty(manager.affectedProjectIds)) {

        response = await ApiUDS.getProjectsUsersRecursively(manager.affectedProjectIds).promise()

        const projectUsersFullCollection = ProjectUsersFullCollection.initFromJson(response)

        _.map(projectUsersFullCollection.models, (projectUser: ProjectUserFull) => {

            // we DO NOT copy customers ???
            if (projectUser.access === ProjectAccess.CLIENT) {
                return
            }

            if (projectUser.isTeam) {
                movedItemsTeamIds.push(projectUser.teamId)
            }

            if (projectUser.isUser) {
                movedItemsUsersIds.push(projectUser.userId)
            }

        })

        movedItemsUsersIds =  _.uniq(movedItemsUsersIds)
        movedItemsTeamIds =  _.uniq(movedItemsTeamIds)
    }

    /************* For Teams ************/

    // let selectedProjectTeamIds: ID[] = []
    let selectedWorkspaceTeamIds: ID[] = []

    // Selected project teams ids
    // if (manager.targetProject && !manager.targetProject.isWorkspace) {
    //     gd.session.projectUsers.filterByProject(manager.targetProject.id, ProjectAccess.LIMITED, true).map((pu: ProjectUserSession) => {
    //         if (pu.isTeam) {
    //             selectedProjectTeamIds.push(pu.teamId)
    //         }
    //     })
    // }

    // addTeamsToTargetProject = addTeamsToTargetProject && !_.isEmpty(selectedProjectTeamIds)

    // Selected workspace teams ids
    if (manager.targetProject?.workspace) {
        const workspaceProjectId = manager.targetProject.workspace.project.id;

        gd.session.projectUsers.filterByProject(workspaceProjectId, ProjectAccess.LIMITED, true).map((pu: ProjectUserSession) => {
            if (pu.isTeam) {
                selectedWorkspaceTeamIds.push(pu.teamId)
            }
        })
    }

    // New
    // let teamsMissingInSelectedProject: ID[] = []
    let teamsMissingInSelectedWorkspace: ID[] = []

    _.map(movedItemsTeamIds, (teamId: ID)=> {
        // if(manager.targetProject && (_.isEmpty(selectedProjectTeamIds) || !selectedProjectTeamIds.includes(teamId))) {
        //     teamsMissingInSelectedProject.push(teamId)
        // }

        if(manager.targetProject?.workspace && (_.isEmpty(selectedWorkspaceTeamIds) || !selectedWorkspaceTeamIds.includes(teamId))) {
            teamsMissingInSelectedWorkspace.push(teamId)
        }
    })

    /*********** For Teams end ************/

    /************* For Users ************/

    // collect target workspace (project) users ids if any (no users for 'Projects' space)
    let selectedWorkspaceUsersIds: ID[] = []
    let selectedProjectUsersIds: ID[] = []

    // collect target project users ids
    if (manager.targetProject) {
        selectedProjectUsersIds = gd.session.projectUsers.filterByProject(manager.targetProject.id, ProjectAccess.LIMITED).map((pu: any) => pu.user.id)
    } else {
        selectedProjectUsersIds = []
    }
    // Add status by manager.showProjectAccess and isEmpty(selectedProjectUsersIds) // Boolean
    addUsersToTargetProject = addUsersToTargetProject && !_.isEmpty(selectedProjectUsersIds)

    if (manager.targetProject?.workspace) {
        const workspaceProjectId = manager.targetProject.workspace.project.id
        selectedWorkspaceUsersIds = gd.session.projectUsers.filterByProject(workspaceProjectId, ProjectAccess.LIMITED).map((pu: any) => pu.user.id)
    }

    // addUsersToTargetWorkspace(Always true) and isEmpty(selectedWorkspaceUsersIds)
    addUsersToTargetWorkspace = addUsersToTargetWorkspace && !_.isEmpty(selectedWorkspaceUsersIds)

    debug && console.log(debug, 'process users', addUsersToTargetProject, addUsersToTargetWorkspace, movedItemsUsersIds, selectedProjectUsersIds, selectedWorkspaceUsersIds)

    // find missing users in target project and workspace (project)
    let usersMissingInSelectedProject: ID[] = []
    let usersMissingInSelectedWorkspace: ID[] = []

    _.map(movedItemsUsersIds, (userId: ID) => {
        if(addUsersToTargetProject && !selectedProjectUsersIds.includes(userId)) {
            usersMissingInSelectedProject.push(userId)
        }

        if(addUsersToTargetWorkspace && !selectedWorkspaceUsersIds.includes(userId)) {
            usersMissingInSelectedWorkspace.push(userId)
        }
    })

    /*********** For Users end *************/


    // teamsMissingInSelectedProject   = _.uniq(teamsMissingInSelectedProject)
    teamsMissingInSelectedWorkspace = _.uniq(teamsMissingInSelectedWorkspace)

    usersMissingInSelectedProject   = _.uniq(usersMissingInSelectedProject)
    usersMissingInSelectedWorkspace = _.uniq(usersMissingInSelectedWorkspace)

   debug && console.log(debug, 'process missing users', {
        // projectTeamIds      : teamsMissingInSelectedProject,
        workspaceTeamIds    : teamsMissingInSelectedWorkspace,

        projectUserIds      : usersMissingInSelectedProject,
        workspaceUserIds    : usersMissingInSelectedWorkspace,
    })



    return {
        // projectTeamIds      : teamsMissingInSelectedProject,
        workspaceTeamIds    : teamsMissingInSelectedWorkspace,

        projectUserIds      : usersMissingInSelectedProject,
        workspaceUserIds    : usersMissingInSelectedWorkspace,
    }
}
